import orderBy from 'lodash/orderBy'

export const goodSorts = [
  {
    name: 'popularity',
    title: 'сначала популярные',
    orderBy: ['popularity desc', 'specialTitle', 'isNew desc', 'title', 'price']
  },
  {
    name: 'novelty',
    title: 'сначала новинки',
    orderBy: ['isNew desc', 'popularity desc', 'specialTitle', 'title', 'price']
  },
  {
    name: 'title',
    title: 'по названию',
    orderBy: ['title', 'popularity desc', 'specialTitle', 'isNew desc', 'price']
  },
  {
    name: 'price',
    title: 'сначала дешевые',
    orderBy: ['price', 'popularity desc', 'specialTitle', 'isNew desc', 'title']
  },
  {
    name: 'price-desc',
    title: 'сначала дорогие',
    orderBy: ['price desc', 'popularity desc', 'specialTitle', 'isNew desc', 'title']
  }
]

export const sortGoods = (goods, sortName = 'popularity') => {
  let goodSort = goodSorts.find(sort => sort.name === sortName)
  if (!goodSort) goodSort = goodSorts[0]

  let fields = []
  let directions = []
  goodSort.orderBy.forEach(item => {
    let [field, direction] = item.split(' ')
    if (direction !== 'desc') direction = 'asc'
    fields.push(field)
    directions.push(direction)
  })

  return orderBy(goods, fields, directions)
}

export const calcDiscount = (catalogType, good, user) => {
  if (catalogType.name !== 'client') return 0
  if (good.maxClientDiscount > 32) return good.maxClientDiscount
  return Math.min(user.stats.clientDiscount, good.maxClientDiscount)
}
